import * as React from "react";
// import RechargeCard from "./RechargeCard";
import api from "../../utils/api";
import RechargeTicketDetails from "./RechargeTicketDetails";
import { Card, CardBody } from "reactstrap";

interface RFIDData {
  bookingDate: string;
  cardAmount: number;
  customerMobileNumber: string;
  customerName: string;
  numberOdAdults: string;
  numberOfChildren: string;
  status: string | null;
  ticketBookingId: number;
  ticketNumber: string;
  ticketRFIdCardRef: string;
  ticketUniqueRFIdNo: string;
}

const RechargeOptions: React.FC = () => {
  // const amounts = ["50", "100", "200", "500", "1000", "200"];
  const [rechargeOptions, setRechargeOptions] = React.useState<
    { cardRechargeMasterId: number; cardAmount: number; isLocked: boolean }[]
  >([]);

  const [cardNumber, setCardNumber] = React.useState<string>("0");
  const [rfidData, setRfidData] = React.useState<RFIDData | null>(null);
  const [rechAmt, setRechAmt] = React.useState<number>(0);
  
  const fetchRechargeOptions = async () => {
    // Fetch recharge options from the API
    try {
      const response = await api.get('/api/CardRechargeMaster/GetAllRechargeAmount'); // replace with your API endpoint
      if ((response.status === 200 || response.status === 201) && Array.isArray(response.data)) {
        setRechargeOptions(response.data);
      } else {
        setRechargeOptions([]);
      }
    } catch (error) {
      console.error("Failed to fetch recharge options:", error);
    }
  };

  React.useEffect(() => {
    fetchRechargeOptions();
  }, []);

  const [selectedAmounts, setSelectedAmounts] = React.useState<number[]>([]);

  const toggleAmount = (amount: number) => {
    setSelectedAmounts(prev =>
      prev.includes(amount) ? prev.filter(a => a !== amount) : [...prev, amount]
    );
  };

  const total = selectedAmounts.reduce((sum, val) => sum + val, 0);

  const handleRFIDCardNumber = async (value: string) => {
    setCardNumber(value);
    // TODO: Implement what should happen when a valid RFID card number is entered
    // console.log("RFID Card Number:", value);
    if(value.length === 10) {
      try {
        const response = await api.get(`/api/RFID/ReadRFID?rfidcardnumber=${value}`);
        if (response.status !== 200) {
          setRfidData(null);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.data;
        setRfidData(data);
      } catch (error) {
        setRfidData(null);
        console.error('Error fetching RFID data:');
      }
    }else{
      setRfidData(null);
      setCardNumber("0");
    }
  };
  return (
    <>
      <Card>
        <header className="bg-white px-4 py-4 fs-5 fw-semibold text-dark border">
          <div className="input-group mb-3">
              <input
            type="text"
            className="form-control"
            placeholder="Enter your RF ID Card number..."
            aria-label="Enter your RF ID Card number"
            aria-describedby="scan-button"
            onChange={(e) => {
                  const value = e.target.value;
                  // if (value.length === 10) {
                  handleRFIDCardNumber(value);
                  // }
            }}
              />
              <button className="btn btn-outline-secondary" type="button" id="scan-button">
            Scan RF ID
              </button>
          </div>
        </header>
        <CardBody>
          <div className="container mt-4">
            <div className="mb-4">
              <div className="position-relative mx-auto" style={{ maxWidth: "600px" }}>
                <input
                  type="text"
                  className="form-control form-control-lg rounded-pill pe-5"
                  placeholder="Search here"
                  onChange={(e) => { setRechAmt(Number(e.target.value)); if(e.target.value === ""){ fetchRechargeOptions(); }}}
                />
                <button
                  className="btn btn-dark position-absolute top-50 translate-middle-y end-0 me-2 p-2 rounded-circle d-flex justify-content-center align-items-center"
                  style={{ width: "40px", height: "40px" }}
                  onClick={() => {
                    const filtered = rechargeOptions.filter((option) =>
                      option.cardAmount.toString().includes(rechAmt.toString())
                    );
                    if(rechAmt === 0 || rechAmt === null || rechAmt === undefined || isNaN(rechAmt)){
                      fetchRechargeOptions();
                    }
                    if(filtered.length > 0){
                      setRechargeOptions(filtered);
                    }else{
                      fetchRechargeOptions();
                    }
                  }}
                >
                  <i className="fa fa-search text-white"></i>
                </button>
              </div>
            </div>
            <div className="row g-2">
              <div className="col-12 col-md-8">
                <div className="flex-grow-1">
                  <div className="row g-3">
                    {rechargeOptions.length === 0 ? (
                      <div className="col-12 text-center">
                        <p>No recharge options available.</p>
                      </div>
                    ) : (
                      rechargeOptions.map((recharge, index) => {
                        const selected = selectedAmounts.includes(recharge.cardAmount);
                        return (
                          <div key={recharge.cardRechargeMasterId ?? index} className="col-12 col-sm-6 col-md-4">
                            {/* <RechargeCard
                            amount={recharge.cardAmount}
                          /> */}
                            <button
                              className={`btn border rounded-3 shadow-sm py-4 px-2 w-100 h-100 ${selected ? 'border-primary' : 'bg-white'}`}
                              style={{ borderWidth: selected ? 3 : undefined }}
                              onClick={() => toggleAmount(recharge.cardAmount)}
                            >
                              <div className="fs-2 fw-bold text-dark text-center">
                                ₹{recharge.cardAmount}
                              </div>
                            </button>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <RechargeTicketDetails total={total} cardNumber={cardNumber} rfidData={rfidData} />
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  )
}
export default RechargeOptions;
